<template>
  <div
    class="b-booking-aside__total-cost mb-20"
    :class="{
      'b-booking-aside__total-cost--miles mb-12': hasDiscount,
    }">
    <div>
      <span v-if="!hasDiscount" class="extrabold">
        {{ dictionary.asideCostTotal }}
      </span>
      <span v-else>{{ mbDictionary.milesNCashAsideTotalCostText }}</span>
      <br />
      <div v-if="!hasDiscount">
        <span v-if="payment?.IsPrepaid">
          {{ dictionary.asideCostTotalPrepaid }}
        </span>
        <span v-else>
          {{ dictionary.asideCostTotalPayOnReturn }}
        </span>
      </div>
    </div>
    <em v-html="payment?.TotalCost"></em>
  </div>

  <div v-if="hasDiscount && milesData" class="b-booking-aside__miles-cost">
    <div class="b-booking-aside__miles-paid-card mb-12">
      <span>{{ mbDictionary.milesNBonusPaidWithCardText }}</span>
      <div class="price d-flex">
        <em>€{{ formattedPriceToLocale(paidWithCard) }}&nbsp;</em>
      </div>
    </div>
    <div class="b-booking-aside__miles-paid-miles">
      <span>{{ mbDictionary.milesNBonusPaidWithMilesText }}</span>
      <div class="price d-flex">
        <em>
          €{{ formattedPriceToLocale(preModifyRedeemDiscountDecimal) }}&nbsp;
        </em>
      </div>
    </div>
  </div>

  <div v-if="hasDiscount && milesData" class="b-booking-aside__total-cost">
    <div>
      <span
        class="extrabold"
        v-html="mbDictionary.milesNBonusModifyRefundText"></span>
    </div>
    <em>€{{ formattedPriceToLocale(priceDifference) }}</em>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    payment: {
      required: true,
      type: Object,
    },
    redeemMilesEnabled: {
      required: false,
      type: Boolean,
    },
    hasDiscount: {
      required: false,
      type: Boolean,
    },
    milesData: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      mbDictionary: {},
      lang: 'en',

      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },

      priceDifference: 0,
      preModifyTotalCostDecimal: 0,
      preModifyRedeemDiscountDecimal: 0,
    }
  },
  computed: {
    paidWithCard() {
      return (
        this.preModifyTotalCostDecimal - this.preModifyRedeemDiscountDecimal
      )
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()

    const {
      priceDifference,
      preModifyTotalCostDecimal,
      preModifyRedeemDiscountDecimal,
    } = lib.getData('bookingData')
    this.priceDifference = priceDifference
    this.preModifyTotalCostDecimal = preModifyTotalCostDecimal
    this.preModifyRedeemDiscountDecimal = preModifyRedeemDiscountDecimal

    if (lib.getData('milesNBonusData')) {
      const { dictionary, configuration } = lib.getData('milesNBonusData')
      this.mbDictionary = dictionary
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.rate = configuration.rate
      this.destinationAllowed = configuration.destinationAllowed
      this.nodeTypeAlias = configuration.nodeTypeAlias

      if (!this.destinationAllowed) {
        this.showMilesNBonus = false
      }
    }
  },
  methods: {
    formattedPriceToLocale(value) {
      return Math.abs(value).toLocaleString(this.lang, this.formatOptions)
    },
  },
}
</script>
